import { toast } from 'react-toastify';
export const updateObject = (oldObject, updatedObject) => {
  return {
    ...oldObject,
    ...updatedObject,
  };
};

export const isEmpty = (value) =>
  value === undefined ||
  value === null ||
  (typeof value === 'object' && Object.keys(value).length === 0) ||
  (typeof value === 'string' && value.trim().length === 0);

export const getUser = () => {
  const access = JSON.parse(localStorage.getItem('token'));
  const user = JSON.parse(localStorage.getItem('user'));
  const refresh = JSON.parse(localStorage.getItem('refresh'));
  const result = {
    access,
    user,
    refresh,
  };

  return result;
};

export const checkAuth = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const token = JSON.parse(localStorage.getItem('token'));
  if (!user) return false;
  if (!token) return false;
  // try {
  //   const { exp } = jwt.decode(token);
  //   if (exp < new Date().getTime() / 1000) {
  //     return false;
  //   }
  // } catch (error) {
  //   return false;
  // }
  return true;
};

export const toastSuccess = (message) => {
  return toast.success(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const toastError = (message, options) => {
  return toast.error(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    ...options,
  });
};
